import React from "react";
import {Question} from "./Question";
import {CustomerForm} from "./CustomerForm"
import {Results} from "./Results"
import { usePLPContext } from "../ProductListingPage/ProductListingPage";

type QuizCollectionProps = {
    json: { 
        title: string;
        list_ID: string;
        name: string;
        questions: any[]
    };
}; 

export type quizContextValue = {
    quizFunctions: any;
}

export const quizContext = React.createContext({} as any);

export const useQuizContext = () => 
    React.useContext<quizContextValue>(quizContext);

export const QuizCollection = ({
    json
}: QuizCollectionProps) => {
    const { quiz, setSearchState } = usePLPContext();

    //Context Functions
    const [currentAnswers, setCurrentAnswers] = React.useState([])
    const [hasSubmitted, setHasSubmitted] = React.useState(false)
 
    //Quiz Functions

    const handleQuizReset = async() => {
        // setFadeEffect('fadeout')
        setCurrentAnswers([])
        setCurrentStep(0)
        quiz.setQuizAnswers([])
        await delay(50)
        // setFadeEffect('fadein')
    }

    const title = json.title

    const questions = json.questions

    const [currentStep, setCurrentStep] = React.useState(0)

    const totalSteps = json.questions.length - 1


    /* Push to GA DataLayer */
    const handleDataLayer = (category, action) => {
        console.log({
            'event': 'QuizCollection',
            'Quiz_Category': category,
            'Quiz_Action': action,
            'Quiz_Pathname': window.location.pathname,
            'Quiz_Results': currentAnswers,
            'Quiz_Email_Registered': hasSubmitted
        })
        dataLayer.push({
            'event': 'QuizCollection',
            'Quiz_Category': category,
            'Quiz_Action': action,
            'Quiz_Pathname': window.location.pathname,
            'Quiz_Results': currentAnswers,
            'Quiz_Email_Registered': hasSubmitted
        })
    }

    const [fadeEffect, setFadeEffect] = React.useState('fadeout')
    const delay = ms => new Promise(res => setTimeout(res, ms));

    React.useEffect(() => {
        delay(50)
        setFadeEffect('fadein')
    },[])

    const nextStep = async () => {
        // setFadeEffect('fadeout')
        await delay(300)
        console.log({currentAnswers})
        if(currentStep <= totalSteps){
            quiz.setQuizAnswers(currentAnswers)
            setCurrentStep(currentStep + 1)
        }        

        if(currentStep == totalSteps){
            quiz.setQuizAnswers(currentAnswers)

            let quizData = []
            quiz.quizAnswers.filter(data => data?.facet ).forEach(data => {
                quizData[data.facet] = data.answers
            })
            console.log(quizData)
            
            setSearchState((prev) => ({
                ...prev,
                refinementList: quizData
            }))
        }


        // await delay(50)
        // setFadeEffect('fadein')
        handleDataLayer('Quiz_Navigation', 'Forward')    
    }
    

    const prevousStep = async () => {
        
        // setFadeEffect('fadeout')
        // await delay(300) 

        // quiz.setQuizAnswers([])
        if(currentStep != 0)
            setCurrentStep(currentStep - 1)

        await delay(50)
        // setFadeEffect('fadein')
        handleDataLayer('Quiz_Navigation', 'Backward')
    }
    
    return (
        <quizContext.Provider value={{
            quizFunctions: {
                title,
                currentAnswers,
                setCurrentAnswers,
                nextStep,
                prevousStep,
                currentStep,
                totalSteps,
                setHasSubmitted,
                handleQuizReset,
                fadeEffect,
                handleDataLayer
            }
        }}>
            <>
                {questions.map((data, index) => (
                    <div key={index}>
                    {index == currentStep &&(
                        <Question key={index} data={data} />
                    )}
                    </div>
                ))}
                <br></br>
                
                {/* Customer Signup Form */}
                {questions[currentStep] == undefined && !hasSubmitted && (
                    <>
                        <CustomerForm list_ID={json.list_ID} />
                    </>
                )}

                {/* Results Overview */}
                {questions[currentStep] == undefined && quiz.quizSubmittedOrSkipped && (
                    <Results/>
                    
                )}
            </>
        </quizContext.Provider>
    );
};
  